import React from 'react';
import { Segmented } from 'antd';

import { GRID, TABLE } from '../icons';

/**
 * The grid/table switch of a list of items (the collection list, a related
 * list). Where the choice is kept is the caller's business (`useViewMode`).
 *
 *   <ViewModeSwitch value={mode} onChange={setMode} isMobile={isMobile} />
 *
 * On a phone the segments are glyphs only (the labels ride as accessible
 * names), like every other toolbar control at 375 px.
 *
 * `extras` adds segments after Grid and Table - the collection list's
 * Worklist. Each is `{ value, label, title, disabled, icon, mobileIcon }`:
 * `icon` is drawn beside the label on a desktop, `mobileIcon` stands for the
 * label on a phone.
 */
export default function ViewModeSwitch({
	value,
	onChange,
	isMobile = false,
	extras = [],
	busy = false,
	className = 'items-page__view-switch',
}) {
	const options = isMobile ? [
		{ value: 'grid', title: 'Grid', icon: <GRID role="img" aria-label="Grid" /> },
		{ value: 'table', title: 'Table', icon: <TABLE role="img" aria-label="Table" /> },
		...extras.map(extra => ({
			value: extra.value,
			title: extra.title,
			disabled: extra.disabled,
			icon: extra.mobileIcon,
		})),
	] : [
		{ value: 'grid', label: 'Grid' },
		{ value: 'table', label: 'Table' },
		...extras.map(extra => ({
			value: extra.value,
			label: extra.label,
			title: extra.title,
			disabled: extra.disabled,
			icon: extra.icon,
		})),
	];

	// The neutral segmented: selected segment chip grey + 600.
	return (
		<Segmented
			className={`${className} segmented--neutral${isMobile ? ' items-page__view-switch--icons' : ''}`}
			value={value}
			onChange={onChange}
			aria-busy={busy}
			options={options}
		/>
	);
}
